import { useState, useEffect } from 'react';

export const DESKTOP_WIDTH = 1024;

const isMobile = () => window.innerWidth < DESKTOP_WIDTH;

export default function useMobileDetect() {
  const [windowSize, setWindowSize] = useState(isMobile());

  function handleResize() {
    setWindowSize(isMobile());
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowSize;
}
